import React from 'react'
import PropTypes from 'prop-types'
import * as request from 'services/request'

class TenantsSelect extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      tenants: []
    }
  }

  componentDidMount () {
    this.getTenants()
  }

  componentDidUpdate () {
    const { selectedTenantId } = this.props

    window.$('.selectpicker').selectpicker('refresh')
    window.$('.selectpicker').val(selectedTenantId)
  }

  async getTenants () {
    const response = await request.authorized(`/tenants`)
    const tenants = await response.json()
    this.setState({ tenants })
  }

  render () {
    const { tenants } = this.state
    const { selectedTenantId, onTenantIdSelected, className } = this.props

    return (
      <div className={`form-group ${className}`}>
        <select
          className='selectpicker form-control'
          title='Select a tenant'
          data-live-search='true'
          onChange={e => onTenantIdSelected(e.target.value)}
          value={selectedTenantId}
        >
          {tenants.map(({ id, name }) => (
            <option key={id} value={id}>
              {name}
            </option>
          ))}
        </select>
        <label
          className='text-danger'
          style={{
            fontSize: 12,
            display: selectedTenantId ? 'none' : 'in-line'
          }}
        >
          Please select a tenant to assign a user
        </label>
      </div>
    )
  }
}

TenantsSelect.propTypes = {
  onTenantIdSelected: PropTypes.func.isRequired,
  selectedTenantId: PropTypes.string,
  className: PropTypes.string
}

export default TenantsSelect



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/tenant-permissions/tenants-select.js